import React, { useState } from 'react'
import { IoCheckmarkOutline } from "react-icons/io5";
import CancelCheckIcon from "../../assets/icons/x-circle-gray.svg";
import deleteIcon from "../../assets/icons/Bin.svg";


const WorkflowChecklist = ({ checklist, addNewChecklist, removeChecklist }) => {


    const [inputData, setInputData] = useState('');

    const inputValue = (e) => {
        setInputData(e.target.value)
    }

    const addItem = () => {
        addNewChecklist(inputData)
        setInputData('')
    }

    const clear = () => {
        setInputData('')
    }

    const deleteChecklist = (index) => {
        removeChecklist(index)
    }

    return (
        <div className='workflow-checklist-wrapper mt-3 p-2'>
            <div className='custom-worflow-checklist-header'>Checklist</div>

            <div className='workflow-checklist-item mt-2'>
                {checklist && checklist?.map((item, index) => {
                    return (
                        <div className='wokflow-cheklist-add-section item-border'>
                            <div key={index}>{item}</div>
                            <div className="frc" style={{ columnGap: "1rem", flexShrink: 0 }}>
                                <img
                                    alt=""
                                    src={deleteIcon}
                                    style={{
                                        opacity: 0.25,
                                        cursor: "pointer",
                                        width: "16px",
                                    }}
                                    onClick={() => deleteChecklist(index)}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>

            <div className='wokflow-cheklist-add-section mt-1'>
                <input type='text'
                    placeholder='Add Item'
                    className='workflow-checklist-input'
                    value={inputData}
                    onChange={inputValue}
                />

                <div className="frc" style={{ columnGap: "1rem", flexShrink: 0 }}>
                    <IoCheckmarkOutline
                        style={{
                            color: "#00246A",
                            fontSize: "1.2rem",
                            cursor: "pointer",
                        }}
                        onClick={addItem}
                    />

                    <img
                        alt=""
                        src={CancelCheckIcon}
                        style={{ cursor: "pointer" }}
                        onClick={clear}
                    />
                </div>

            </div>
        </div>
    )
}

export default WorkflowChecklist


